import { useAppModel } from '@models/App/AppModel';

export function useVideoPlayerSettings() {
  const app = useAppModel();

  return app.videoPlayerSettings;
}
